/**
 * useVisitPing — fire-and-forget analytics ping for page visits.
 *
 * Guards:
 *  - Once per tab session (sessionStorage key derived from path).
 *  - Scoped by `source` so admin stats can separate:
 *      • "landing" = public marketing/SEO pages
 *      • "app"     = logged-in in-app usage
 *  - Silent on failure — the dashboard loads either way.
 *
 * Call near the top of a page component:
 *   useVisitPing("landing");  // or "app"
 */
import { useEffect } from "react";
import { api } from "@/lib/api";

export function useVisitPing(source) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const path = window.location.pathname || "/";
    const key = `famfeel_visit_pinged::${source}::${path}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      /* private mode — still ping once per render cycle, not worth gating */
    }
    api
      .pingVisit({
        path,
        referrer: typeof document !== "undefined" ? document.referrer || null : null,
        source,
      })
      .catch(() => {});
  }, [source]);
}
